import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { nanoid } from 'nanoid';

const { baseUrl } = window.conviva;

const RedirectToNexaWithId = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const id = nanoid();
    navigate(`${baseUrl}/dashboard/nexa/${id}`, { replace: true }); // prevents /nexa from staying in history
  }, [navigate]);

  return null; // or a loading spinner if needed
};

export default RedirectToNexaWithId;
